import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.function.name.js";
export function actions(state) {
  return state.actions;
}
export function actionByName(state) {
  return function (name) {
    return state.actions.find(function (o) {
      return o.name === name;
    });
  };
}
export function notCommittedActions(state) {
  return state.notCommittedActions;
}
export function notCommittedActionsMeta(state) {
  return state.notCommittedActionsMeta;
}
export function multiDetach(state) {
  return state.multiDetach;
}